import { useQuery } from '@tanstack/react-query'

import type { VacationType } from '@czas/shared'

import { apiFetch } from '@/lib/api'

export interface VacationTypeHours {
  days: number
  /** Procent pełnego dnia zaliczony temu typowi (L4 = 80). */
  percent: number
  hours: number
}

export type MonthlyProgressStatus = 'behind' | 'on_track' | 'completed' | 'exceeded'

export interface MonthlyProgress {
  yearMonth: string
  fullTimeNorm: number
  employmentFraction: number
  /** true = admin nie ustawił etatu, backend przyjął pełny (1/1). */
  employmentFractionAssumed: boolean
  target: number
  workingDaysInMonth: number
  workingDaysElapsed: number
  workingDaysRemaining: number
  dailyTarget: number
  /** Ile godzin ma PEŁNY dzień urlopu: 8h × etat. L4 zalicza 80% tej liczby. */
  vacationDayHours: number
  workedHours: number
  vacationDays: number
  vacationHours: number
  /** Rozbicie per typ — pozwala pokazać, że L4 nie liczy się jak pełny dzień. */
  vacationByType: Record<VacationType, VacationTypeHours>
  /** Dni urlopu bezpłatnego — NIE wliczają się do godzin. */
  unpaidLeaveDays: number
  totalCredited: number
  percentComplete: number
  status: MonthlyProgressStatus
  remainingHours: number
  averageHoursPerRemainingDay: number
}

export function useMyMonthlyProgress(yearMonth?: string) {
  return useQuery({
    queryKey: ['my-monthly-progress', yearMonth ?? 'current'],
    queryFn: async () => {
      const params = yearMonth ? `?yearMonth=${yearMonth}` : ''
      const res = await apiFetch<{ progress: MonthlyProgress | null }>(
        `/api/work-sessions/my-monthly-progress${params}`,
      )
      return res.progress
    },
    refetchInterval: 5 * 60 * 1000,
    staleTime: 60 * 1000,
  })
}
